import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _regeneratorRuntime from "/data/shupian/qds-scrmnet-0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/data/shupian/qds-scrmnet-0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import { env } from '@/config';
import { initApi } from '@/api/init';
import { GetRequest } from '@/utils/index';
var JS_API_LIST = ['getContext', 'getCurExternalContact', 'openUserProfile', 'sendChatMessage', 'openUserProfile', 'navigateToAddCustomer', 'openEnterpriseChat', 'openExistedChatWithMsg', 'shareToExternalMoments', 'previewFile', 'launchMiniprogram', 'getCurExternalChat', 'updateEnterpriseChat', 'shareToExternalChat', 'createCorpGroupChat', 'updateCorpGroupChat', 'openDefaultBrowser'];
import { login } from '@/api/user';
import { deviceLogin } from '@/utils/marketValid';
import router from '@/router';
import { getEntranceUtils } from '@/utils/getContext';

/** config注入的是企业的身份与权限**/

export var initConfig = function initConfig() {
  return new Promise(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
      var res, timestamp, nonceStr, signature, corpId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return initApi.getConfig();
          case 3:
            res = _context.sent;
            timestamp = res.timestamp, nonceStr = res.nonceStr, signature = res.signature, corpId = res.corpId;
            wx.config({
              beta: true,
              debug: false,
              appId: corpId,
              timestamp: timestamp,
              nonceStr: nonceStr,
              signature: signature,
              jsApiList: JS_API_LIST
            });
            wx.ready(function (res) {
              console.log('企业成', res);
              console.log('企业注入接口api', JS_API_LIST);
              resolve(true);
            });
            wx.error(function (err) {
              // alert('false')
              // console.log('企业失败', err)
              reject(false);
            });
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            reject(_context.t0);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

/** agentConfig注入的是应用的身份与权限**/

export var initAgentConfig = function initAgentConfig() {
  return new Promise(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
      var res, timestamp, nonceStr, signature, corpId, AgentId;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return initApi.getAgentConfig();
          case 3:
            res = _context3.sent;
            timestamp = res.timestamp, nonceStr = res.nonceStr, signature = res.signature, corpId = res.corpId, AgentId = res.AgentId;
            console.log('initAgentConfig参数', timestamp, nonceStr, signature, corpId, AgentId);
            wx.agentConfig({
              corpid: corpId,
              agentid: AgentId,
              timestamp: timestamp,
              nonceStr: nonceStr,
              signature: signature,
              jsApiList: JS_API_LIST,
              success: function success(data) {
                return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        console.log('aginit成功', data);
                        console.log('应用注入接口', JS_API_LIST);
                        // await getUserId()

                        resolve(data);
                      case 3:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }))();
              },
              fail: function fail(err) {
                console.log('aginit失败', err);
                if (err.errMsg.indexOf('function not exist') > -1) {
                  alert('版本过低请升级');
                }
                reject(err);
              }
            });
            _context3.next = 13;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            console.log('aginit失败2', _context3.t0);
            reject(_context3.t0);
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 9]]);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};

/**
 * @description:获取入口环境,判断是否需要获取外部联系人
 * @params{urlFlag}-路由标识
 * @params{entry}-环境入口标识group_chat_tools-群聊,single_chat_tools-单聊
 *
 * **/
export var getContextFunc = function getContextFunc() {
  return new Promise(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve, reject) {
      var res, entry, urlParams, urlFlag;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return getEntranceUtils.getContext();
          case 3:
            res = _context4.sent;
            entry = res.entry;
            urlParams = window.location.hash; // 获取浏览器后缀
            urlFlag = urlParams.slice(2);
            console.log('入口环境判断参数', res);
            sessionStorage.setItem('entry', res.entry);
            console.log('url地址参数', urlFlag);

            // 1.判断是否单聊
            // 2.判断对应路由标识
            if (!(res.entry == 'group_chat_tools')) {
              _context4.next = 14;
              break;
            }
            // urlFlag == 'business-clues' ||
            if (urlFlag == 'customer-information' && !sessionStorage.getItem('groupChat')) {
              // router.push({
              //   path: '/group-customers-information' // 由群聊打开侧边栏，客户资料
              //   // path:'/abnnormal-page',
              //   // query:{
              //   //   name:'此功能暂未对群聊开放，敬请期待'
              //   // }
              // })

              sessionStorage.setItem('initGroup', 'initGroup');
            } else if (urlFlag == 'customer-information' && sessionStorage.getItem('groupChat')) {
              try {
                wx.closeWindow();
              } catch (error) {
                console.log(error);
              }
            }
            _context4.next = 17;
            break;
          case 14:
            if (!(res.entry == 'single_chat_tools')) {
              _context4.next = 17;
              break;
            }
            _context4.next = 17;
            return getUserId();
          case 17:
            resolve(res);
            _context4.next = 23;
            break;
          case 20:
            _context4.prev = 20;
            _context4.t0 = _context4["catch"](0);
            console.log('入口环境报错', _context4.t0);
          case 23:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 20]]);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }());
};

/**
 * @description:获取当前外部联系人userid
 * **/
export var getUserId = function getUserId() {
  return new Promise(function (resolve, reject) {
    try {
      wx.invoke('getCurExternalContact', {}, function (res) {
        console.log('当前外部联系人userID', res);
        if (res.err_msg == 'getCurExternalContact:ok') {
          localStorage.setItem('externalUserId', res.userId);
          sessionStorage.setItem('externalUserId', res.userId);
          resolve(res.userId);
        } else {
          // console.log('获取外部联系人失败')
          sessionStorage.clear();
          localStorage.clear();
          // 错误处理
          router.push({
            path: '/no-jurisdiction'
          });
        }
      });
    } catch (error) {
      // console.log('获取外部联系人失败',error)
      reject(error);
    }
  });
};

/** *
 * @description:获取登录信息
 *
 * **/

var getAuth = function getAuth() {
  // 每次进来都清空，然后再去拿
  // sessionStorage.clear()
  // localStorage.clear()
  return new Promise(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve, reject) {
      var dictionLogin, clientType, urlParams, urlState, corpId, params;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            dictionLogin = deviceLogin(); // true-电脑登录,false-手机登录
            if (dictionLogin) {
              clientType = 'COMDIC_TERMINAL_WECHAT_BUS_PC';
            } else {
              clientType = 'COMDIC_TERMINAL_WECHAT_BUS_APP';
            }
            urlParams = GetRequest(window.location.href);
            console.log('这是企微链接参数', urlParams);
            urlState = urlParams.state.split('-');
            sessionStorage.setItem('corpId', urlState[0]);
            sessionStorage.setItem('AgentId', urlState[1]);
            corpId = sessionStorage.getItem('corpId');
            localStorage.setItem('code', urlParams.code);
            params = {
              platformType: 'COMDIC_PLATFORM_QIDASHUN',
              accountChannel: 'AUTH_WECHAT_BUS_THIRD',
              client: clientType,
              dataJson: {
                code: urlParams.code,
                corpId: corpId,
                loginType: 3
              },
              userType: 'MERCHANT_USER'
            };
            login(params).then(function (res) {
              if (res.code == 200) {
                _Toast({
                  message: '授权成功',
                  type: 'success'
                });
                localStorage.setItem('imUserId', res.data.imUserId);
                localStorage.setItem('userId', JSON.stringify(res.data.userId));
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('mchInfo', JSON.stringify(res.data.mchInfo));
                localStorage.setItem('userInfo', JSON.stringify(res.data));
                localStorage.setItem('entUserId', JSON.stringify(res.data.qywxUserId));
                resolve(res.data);
              } else {
                console.log('请求错误:', res.message);
                // sessionStorage.clear()
                // localStorage.clear()
                // 错误处理
                router.push({
                  path: '/no-jurisdiction'
                });
                // Toast({ message: res.message, type: 'error' })
                reject(res.message);
              }
            }).catch(function (err) {
              console.log('请求错误', err);
              // 错误处理
              router.push({
                path: '/no-jurisdiction'
              });
              reject(err);
            });
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }());
};

/**
 * @description:获取当前群聊ID
 * @params{*}
 * **/
export var getChatId = function getChatId() {
  return new Promise(function (resolve, reject) {
    try {
      wx.invoke('getCurExternalChat', {}, function (res) {
        if (res.err_msg == 'getCurExternalChat:ok') {
          var chatId = res.chatId; // 返回当前外部群的群聊ID
          sessionStorage.setItem('chatId', chatId);
          resolve(res);
        } else {
          console.log('获取群聊ID失败!!!!!!!!', res);
          reject(res);
          // 错误处理
        }
      });
    } catch (error) {
      // console.log('获取外部联系人失败',error)
      reject(error);
    }
  });
};

/**
 * @description:初始化默认先进入商户中心的login接口，获取到用户信息及token
 * @params{*}
 * **/
export var initLogin = function initLogin(windowUrl, defaultCorpId, defaultCode) {
  return new Promise(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve, reject) {
      var dictionLogin, clientType, params, urlParams, urlState, corpId;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            dictionLogin = deviceLogin(); // true-电脑登录,false-手机登录
            params = {};
            if (dictionLogin) {
              clientType = 'COMDIC_TERMINAL_WECHAT_BUS_PC';
            } else {
              clientType = 'COMDIC_TERMINAL_WECHAT_BUS_APP';
            }
            if (defaultCorpId && defaultCode) {
              params = {
                platformType: 'COMDIC_PLATFORM_QIDASHUN',
                accountChannel: 'AUTH_WECHAT_BUS_THIRD',
                client: clientType,
                dataJson: {
                  code: defaultCode,
                  corpId: defaultCorpId,
                  loginType: 3
                },
                userType: 'MERCHANT_USER'
              };
            } else {
              urlParams = GetRequest(windowUrl);
              urlState = urlParams.state.split('-');
              console.log('urlState', urlState);
              console.log('urlParams', urlParams);
              sessionStorage.setItem('corpId', urlState[0]);
              sessionStorage.setItem('AgentId', urlState[1]);
              sessionStorage.setItem('bizId', urlState[2]);
              corpId = sessionStorage.getItem('corpId');
              localStorage.setItem('code', urlParams.code);
              sessionStorage.setItem('routerCode', urlParams.code);
              params = {
                platformType: 'COMDIC_PLATFORM_QIDASHUN',
                accountChannel: 'AUTH_WECHAT_BUS_THIRD',
                client: clientType,
                dataJson: {
                  code: urlParams.code,
                  corpId: corpId,
                  loginType: 3
                },
                userType: 'MERCHANT_USER'
              };
            }
            // const urlParams = GetRequest(windowUrl)
            // const urlState = urlParams.state.split('-')
            // console.log('urlState', urlState)
            // console.log('urlParams', urlParams)
            // sessionStorage.setItem('corpId', urlState[0])
            // sessionStorage.setItem('AgentId', urlState[1])
            // sessionStorage.setItem('bizId', urlState[2])

            // const corpId = sessionStorage.getItem('corpId')
            // localStorage.setItem('code', urlParams.code)
            // sessionStorage.setItem('routerCode', urlParams.code)
            // const params = {
            //   platformType: 'COMDIC_PLATFORM_QIDASHUN',
            //   accountChannel: 'AUTH_WECHAT_BUS_THIRD',
            //   client: clientType,
            //   dataJson: {
            //     code: defaultCode || urlParams.code,
            //     corpId: defaultCorpId || corpId,
            //     loginType: 3
            //   },
            //   userType: 'MERCHANT_USER'
            // }

            login(params).then(function (res) {
              if (res.code == 200) {
                localStorage.setItem('userId', JSON.stringify(res.data.userId));
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('mchInfo', JSON.stringify(res.data.mchInfo));
                localStorage.setItem('userInfo', JSON.stringify(res.data));
                localStorage.setItem('entUserId', JSON.stringify(res.data.qywxUserId));
                resolve(res);
              } else {
                // this.$toast(res.message)

                // 错误处理
                router.push({
                  path: '/no-jurisdiction'
                });
                reject(res.message);
              }
            }).catch(function (err) {
              console.log('请求错误', err);
              // 错误处理
              router.push({
                path: '/no-jurisdiction'
              });
              reject(err);
            });
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }());
};

/**
 * @description:变更群成员接口
 * @params{*}
 * **/
// export const updateChatMember = (chatId, userIdsToAdd) => {
//   return new Promise((resolve, reject) => {
//     try {
//       wx.invoke(
//         'updateEnterpriseChat',
//         {
//           chatId: chatId, //通过企业微信创建群聊接口返回的chatId
//           // userIdsToAdd: userIdsToAdd //参与会话的企业成员列表
//           userIdsToAdd: '130733'
//         },
//         res => {
//           if (res.err_msg == 'updateEnterpriseChat:ok') {
//             console.log('变更群成员成功', res)
//             resolve(res)
//           } else {
//             console.log(chatId, userIdsToAdd);
//             console.log('变更群成员失败', res)
//           }
//         }
//       )
//     } catch (error) {
//       console.log('变更群成员失败', error)
//       reject(error)
//     }
//   })
// }

// 打开群聊
export var updateChatMember = function updateChatMember(chatId, entUserId) {
  return new Promise(function (resolve, reject) {
    try {
      wx.openEnterpriseChat({
        // 注意：userIds和externalUserIds至少选填一个。内部群最多2000人；外部群最多500人；如果有微信联系人，最多40人
        userIds: '',
        //参与会话的企业成员列表，格式为userid1;userid2;...，用分号隔开。
        externalUserIds: '',
        // 参与会话的外部联系人列表，格式为userId1;userId2;…，用分号隔开。
        groupName: '',
        // 会话名称。单聊时该参数传入空字符串""即可。
        chatId: chatId,
        // 若要打开已有会话，需指定此参数。如果是新建会话，chatId必须为空串
        success: function success(res) {
          // var chatId = res.chatId //返回当前群聊ID，仅当使用agentConfig注入该接口权限时才返回chatId
          console.log('进入成功', res);
          // 回调
        },
        fail: function fail(res) {
          if (res.errMsg.indexOf('function not exist') > -1) {
            // alert('版本过低请升级')
            console.log('版本过低请升级');
          } else {
            console.log('进入群失败', res);
          }
        }
      });
    } catch (error) {
      console.log('变更群成员失败', error);
      reject(error);
    }
  });
};

/**
 * @description:打开已有的会话并发送链接————目前仅能发送链接
 * @params{*}
 * chatId 群聊ID
 * shareTitle 链接标题
 * shareDesc 链接描述
 * shareLink 链接地址
 * shareImgUrl 链接图片地址
 * **/
export var openChatShareLink = function openChatShareLink(chatId, shareTitle, shareDesc, shareLink, shareImgUrl, onResult) {
  return new Promise(function (resolve, reject) {
    try {
      wx.invoke('openExistedChatWithMsg', {
        chatId: chatId,
        msg: {
          msgtype: 'link',
          //目前只支持链接消息，固定填link
          link: {
            title: shareTitle,
            desc: shareDesc,
            url: shareLink,
            imgUrl: shareImgUrl ? shareImgUrl : 'https://sp-crm-1258378054.cos.ap-chengdu.myqcloud.com/%E8%96%AF%E7%89%87log.jpg'
          }
        }
      }, function (res) {
        if (onResult) onResult(res);
        if (res.err_msg == 'openExistedChatWithMsg:ok') {
          console.log('打开会话发送链接成功', res);
        } else {
          console.log('打开会话发送链接失败', res);
        }
      });
    } catch (error) {
      console.log('打开会话发送链接失败', error);
      reject(error);
    }
  });
};
var init = function init() {
  return new Promise(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(resolve, reject) {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return getAuth();
          case 3:
            _context7.next = 5;
            return initConfig();
          case 5:
            _context7.next = 7;
            return initAgentConfig();
          case 7:
            _context7.next = 9;
            return getContextFunc();
          case 9:
            //

            // }
            resolve();
            _context7.next = 15;
            break;
          case 12:
            _context7.prev = 12;
            _context7.t0 = _context7["catch"](0);
            reject(_context7.t0);
          case 15:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[0, 12]]);
    }));
    return function (_x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }());
};
export default init;